import { all, call, put, select, takeLatest } from "redux-saga/effects";
import { normalize, schema } from "normalizr";

import { showError } from "../../utils/sagasErrorHandler";

import { getUsersRequest } from "./api";
import { getUsers, setUsers } from "./actions";
import { usersSelector } from "./selectors";

const usersSchema = new schema.Entity("users" , {}, { idAttribute: "id" });
const usersListSchema = new schema.Array(usersSchema);

export function* getUsersWorker() {
    try {
        const { codes } = yield select(usersSelector);
        if(!codes.length){
            yield put(setUsers({ isLoadingUsers: true }));
            const { users } = yield call(getUsersRequest);
            const { result, entities } = normalize(users, usersListSchema);
            yield put(setUsers({
                isLoadingUsers: false,
                codes: result,
                users: entities.users
            }));
        }
    } catch (error) {
        yield put(setUsers({ isLoadingUsers: false }));
        showError(error);
    }
}

export function* getUsersSaga() {
    yield all([
        yield takeLatest(getUsers, getUsersWorker)
    ]);
}
